import InteractiveTable from '../tables/InteractiveTable'
import classes from '../tables/Table.module.css'
import '../css_styles/button_styles.css'

function TeamTable(props){

    let isSelection = false
    props.team.forEach((member) => {
        if (member['selected'] === true) {
            isSelection = true;
            // break out of the loop once a selected member is found
                    return;
        }
    });


    let actionPanel = (<></>);
    if (isSelection === true) {
        actionPanel = props.actionPanel.map((action, index) => (
            <button className={'tableButton'} key={index} onClick={action.action}>
                {action.title}
            </button>
        ));
    }

        
    return(<>
        <div style={{position: 'relative', left:'3%', width:'94%'}}>
            <InteractiveTable colNames={props.colNames} tableRows={props.team} inputHandler={props.onInput}/>
            <div className={classes.buttonContainer} >
                <button className={'tableButton'} onClick={props.onAddRow} >Add</button>
                {actionPanel}
            </div>
        </div>
    </>
    );
}

export default TeamTable;


